/** Notify SEO/head listeners after programmatic history updates. */
export function notifyUrlChange() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event('takshify-parashari-url-change'));
}
